// import { environment } from "src/environments/environment";

export class AppConst {
	// encryption key
	public static readonly ENC_KEY = "!ServiceGalaxy";
	public static readonly MAX_TRUCKS = 30

	// API KEY
	public static readonly API_KEY = "1234";

	// numberValidation
	public static readonly NUMBER_WITH_TWO_DECIMAL =
		/^\s*(?=.*[1-9])\d*(?:(\.|\,)\d{1,2})?\s*$/;
	public static readonly NUMBER_WITH_ZERO_AND_TWO_DECIMAL =
		/^\s*(?=.*[0-9])\d*(?:(\.|\,)\d{1,2})?\s*$/;
	//emailValidation
	public static readonly EMAIL_PATTERN =
		`^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$`;

	public static readonly DATE_FORMAT = `dd MMM YYYY`;
	public static readonly TIME_FORMAT = `shortTime`;
	public static readonly PASSWORD_PATTERN =
		`(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&])[A-Za-z0-9\d@$!%*?&].{7,19}`;

	public static readonly ZIPCODE_PATTERN = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

	public static readonly WEBSITE_PATTERN = `(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?`;

	// API BASE URL
	// public static readonly API_BASE_URL = environment.API_BASE_URL;

	public static readonly APPLICATION_BASE_URL = window.location.origin;

	public static readonly startYear = 2022;




	// server HTTP header status code
	public static readonly HTTP_STATUS: HttpStatus = {
		OK: 200,
		SERVER_INTERNAL_ERROR: 500,
		FORBIDDEN: 401,
		IFNOTOK: 201,
		BAD_REQUEST: 400,
		NOT_FOUND: 404,
		NO_CONTENT: 204,
	};
	public static readonly SERVER_CODES = {
		VALIDATION_ERROR: "E103",
	};
	public static readonly ERROR_MESSAGES = {
		IMAGE_DIMENSIONS:
			"Image should have min dimensions {{width}}X{{height}}",
		SERVER_ERROR: "Something went wrong",
	};
	public static STORAGE_KEYS = {
		USER_TOKEN: 'USER_TOKEN',
		USER_ID: 'USER_ID',
		USER_DETAILS: 'USER_DETAILS',
		USER_TYPE: 'userType'
	};
	public static MAXLENGTH = {
		clientName: 25,
		companyName: 50,
		phoneNumber: 10,
		pinCode: 10,
		email: 50,
		serviceName: 25,
		title: 100
	}
	public static readonly months = [
		{ name: 'Jan', value: 1 },
		{ name: 'Feb', value: 2 },
		{ name: 'Mar', value: 3 },
		{ name: 'Apr', value: 4 },
		{ name: 'May', value: 5 },
		{ name: 'Jun', value: 6 },
		{ name: 'Jul', value: 7 },
		{ name: 'Aug', value: 8 },
		{ name: 'Sep', value: 9 },
		{ name: 'Oct', value: 10 },
		{ name: 'Nov', value: 11 },
		{ name: 'Dec', value: 12 }
	];
}


export interface HttpStatus {
	OK: number;
	IFNOTOK: number;
	NOT_FOUND: number;
	FORBIDDEN: number;
	BAD_REQUEST: number;
	SERVER_INTERNAL_ERROR: number;
	NO_CONTENT: number;
}
export interface AdminProfile {
	firstName: String,
	lastName: String,
	email: String,
	profilePic: String
}


export const APP_CONSTANT = {
	DURATION: [
		{
			value: 'Monthly'
		}
	],
	DASHBOARD: {
		dashboard: 'Dashboard',
		client: 'Total Client',
		customer: 'Total Customers',
		employees: 'Total Employees',
		emailCount: 'Total Emails',
		clientPayMonthly: 'Payments from client Monthly',
		clientPayMonthlyByCreditCard: 'Payments collected monthly from Credit Card',
		distanceApiHits: 'Distance API hits (Multi Year)',
		distanceApiHitsCost: 'Distance API hits (Cost)',
		totalPayment: 'Total payments monthly',
		marketingEmails: 'Marketing Emails Sent (Multi Year)',
		marketingEmailsCost: 'Marketing Emails Sent (Cost)',
		marketingEmailsClient: 'Marketing Emails Sent to clients.',
		MultiYear: 'Multi year Graph',
		distanceClient: 'Distance API hit count by clients',

		SMS: 'SMS Sent',
		smsClient: 'SMS Sent to clients.',
		smsSent: 'SMS Sent (Multi Year)',
		smsSentCost: 'SMS Sent (Cost)',

		AI: 'AI Minutes Used',
		AIClient: 'AI minutes Used per Client.',
		AISent: 'AI Minutes (Multi Year)',
		AICost: 'AI Minutes Used (Cost)',

	},
	CLIENT: {
		SMS: {
			sayYes: 'Yes',
			title: 'Are you sure you want to unassign this number? ',
			img: 'assets/images/block.png',
			sayNo: "Cancel",
		},
		BLOCK: {
			sayYes: 'Suspend',
			title: 'Are you sure you want to suspend this client with name ',
			img: 'assets/images/block.png',
			sayNo: "Cancel",
		},
		UNBLOCK: {
			sayYes: 'Unblock',
			title: 'Are you sure you want to unblock this client with name ',
			img: 'assets/images/block.png',
			sayNo: "Cancel",
		},
		DELETE: {
			sayYes: 'Delete',
			title: 'This client will be removed permanently & cannot be recovered!!',
			img: 'assets/images/delete.png',
			sayNo: "Cancel",
		},
		ONLINE: {
			sayYes: 'Pay now',
			title: 'Do you want to make online payment now?',
			img: '',
			sayNo: "Later",
		}
	},
	LOGOUT: {
		logout: 'Logout',
		title: 'Are you sure you want logout?',
		cancel: 'Cancel'
	},
	FORGOTPASSWORD: {
		successMsg: 'Reset password link has been sent successfully to you email id!!',
		errorMsg: 'Email not found.Please check your email!!'
	},
	VERIFYEMAIL: {
		success: {
			heading: 'Verification Successful',
			subHeading: 'Click on reset button to reset your password.',
			image: 'assets/images/check.svg',
			button: 'Reset Password'
		},
		failed: {
			heading: 'Verification Failed',
			subHeading: 'Please check you email address.',
			image: 'assets/images/close-circle-fill.png',
			button: 'Back to Login'
		},
		session: {
			heading: 'Session Expired',
			subHeading: '',
			image: 'assets/images/close-circle-fill.png',
			button: 'Back to Login'
		}
	},
	PASSWORDUPDATE: {
		heading: 'Password Updated',
		subHeading: 'Your Password has been successfully Changed.',
		image: 'assets/images/check.svg',
		button: 'Back to Login'
	},

	SUBSCRIPTION: {
		UPDATE: {
			sayYes: 'Update',
			title: 'Are you sure you want to update the subscription?',
			img: 'assets/images/check.svg',
			sayNo: "Cancel",
		},
		CANCEL: {
			sayYes: 'Yes',
			title: 'Are you sure you want to cancel the subscription?',
			img: 'assets/images/delete.png',
			sayNo: "No",
		}
	},


	VALIDATION: {
		email: 'Email id is required',
		validEmail: 'Please enter a valid email address',
		password: 'Please type your password',
		services: 'Industry is required',
		companyName: 'Company Name is required',
		clientName: 'Client Name is required',
		phoneNumber: 'Phone Number is required',
		address: 'Address is required',
		city: 'City is required',
		state: 'State is required',
		country: 'Country is required',
		zipCode: 'Zipcode is required',
		profile: 'Profile image is required',
		newPassword: 'New Password is required',
		oldPassword: 'Current Password is required',
		confirmPassword: 'Confirm Password is required',
		validNewPassword: 'Enter a valid password',
		validZipCode: 'Enter a valid Zipcode',
		serviceName: 'Industry Name is required',
		date: 'Date is required',
		time: 'Time is required'
	}
}


